import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Country and Document Type"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://morrisonrecordsbureau.com/contact-us/",
      target: "_blank",
      class: "link-primary fw-bolder"
    }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Country", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Country", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Choose your document type", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select One", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "fv-row mb-10"
}
const _hoisted_12 = {
  key: 0,
  class: "form-label text-dark fs-6"
}
const _hoisted_13 = {
  key: 1,
  class: "form-label text-dark fs-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Field, {
        name: "citizenship_country",
        class: "form-control form-control-lg form-control-solid",
        "data-control": "select2",
        "data-hide-search": "true",
        "data-placeholder": "Month",
        as: "select",
        modelValue: _ctx.formData.citizenship_country,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.citizenship_country) = $event))
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
            return (_openBlock(), _createElementBlock("option", {
              key: country.name,
              value: country.name
            }, [
              _createElementVNode("span", null, _toDisplayString(country.name), 1)
            ], 8, _hoisted_6))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_ErrorMessage, {
        name: "citizenship_country",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_Field, {
        name: "doc_type",
        class: "form-control form-control-lg form-control-solid",
        "data-control": "select2",
        "data-hide-search": "true",
        "data-placeholder": "Month",
        as: "select",
        modelValue: _ctx.formData.doc_type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.doc_type) = $event))
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.docTypesOptions), (docType) => {
            return (_openBlock(), _createElementBlock("option", {
              key: docType,
              value: docType
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.docTypesOptions[docType]), 1)
            ], 8, _hoisted_10))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_ErrorMessage, {
        name: "doc_type",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    (_ctx.isIdCard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.isGhanaCard)
            ? (_openBlock(), _createElementBlock("label", _hoisted_12, "Enter your TIN or your Ghana card Personal ID Number for verification"))
            : (_openBlock(), _createElementBlock("label", _hoisted_13, "Enter your ID Number ")),
          _createVNode(_component_Field, {
            name: "id_number",
            class: "form-control form-control-lg form-control-solid",
            "data-hide-search": "true",
            placeholder: "Eg. P0012345678 or GHA-123456789-1"
          }),
          _createVNode(_component_ErrorMessage, {
            name: "id_number",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}